import { createContext, useContext } from "react";
export type RecordContactTarget = { customerId: string; phone: string; name: string };
export type TechnicianTextTarget = { id: string; name: string; phone: string };
export const RecordCommunicationsContext = createContext<{
  textsOpen?: boolean;
  openText?: (target: RecordContactTarget) => void;
  openTechnicianText?: (target: TechnicianTextTarget) => void;
  openCalls?: (target: RecordContactTarget) => void;
}>({});
export const useRecordCommunications = () => useContext(RecordCommunicationsContext);
